import { ViewUpdateTpr } from './../../view-update-tpr.class';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ViewUpdateTprApiService } from '../../../../../../modules/api/view-update-tpr-api.service';
import { defaultIfEmpty, filter, finalize, map } from 'rxjs/operators';
import { TprecmAuthorizationService } from '../../../authorization/tprecm-authorization.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'tpr-process-kit',
    templateUrl: './tpr-process-kit.template.html',
    styleUrls: ['../../../tprecm.style.scss', './tpr-process-kit.scss']
})
export class TprProcessKitComponent {

    disabled = false;
    private _selectedTpr: ViewUpdateTpr;

    get selectedTpr(): ViewUpdateTpr {
        return this._selectedTpr;
    }

    @Input()
    set selectedTpr(value: ViewUpdateTpr) {
        this.disabled = false;
        if (value) {
            this._selectedTpr = value;
        } else {
            this._selectedTpr = new ViewUpdateTpr();
            this.disabled = true;
        }
    }

    @Input()
    reSourced = false;

    @Input()
    inActive = false;

    @Output()
    updateEvent = new EventEmitter<any>();

    availOpts: any[] = ['Avail', 'N/Avail', 'N/R'];

    constructor(
        private readonly viewUpdateTprApiService: ViewUpdateTprApiService,
        private readonly auth: TprecmAuthorizationService,
        private readonly toastr: ToastrService
    ) { }

    fieldAuthorized(field: string) {
        return this.auth.getAuthorizationByField(field);
    }

    onGenericFieldChange(fieldName: string, fieldValue: any, obj?: any) {
        if (obj) {
            obj[fieldName] = fieldValue;
        }

        if (fieldName === 'pkApprDate') {
            if (!this.selectedTpr.gdAndTSel || !this.selectedTpr.pkWeldSel || !this.selectedTpr.pkProdInfoSel || !this.selectedTpr.pkCriteriaSel || !this.selectedTpr.datumMatrixSel) {
                this.toastr.error('You must make a selection for GD & T, Die Lineup, Product Info, Criteria Chk List ' +
                    'and Datum Matrix before entering the Posted in eRed Book Site date. Please try again.');
                this.selectedTpr.pkApprDate = undefined;
                return;
            }
        }

        this.disabled = true;
        const params = {
            toolId: this.selectedTpr.toolId,
            tprToolId: this.selectedTpr.tprToolId,
            calcFieldsRequired: false,
            fieldName,
            fieldValue
        };
        this.viewUpdateTprApiService.updateGenericTprField(params)
            .pipe(
                filter(Boolean),
                defaultIfEmpty({ data: [], totalCount: 0 }),
                map((response: any) => response.data[0]),
                finalize(() => this.disabled = false)
            ).subscribe((updatedTpr: any) => this.updateEvent.emit(updatedTpr));
    }

    getEtac() {
        return [
            'ETAC Inside',
            'CTAC',
            'Mini ETAC',
            'ETAC',
            'ITAC'
        ].some(val => val === this.selectedTpr.typeName);
    }

    getTci() {
        return this.selectedTpr.designSource === 'TCI';
    }
}
